import { BuyerCakeScheduleAction, EmptyBuyerCakeSchedule } from './BuyerCakeScheduleConstants';
import { BuyerCakeScheduleState } from './BuyerCakeScheduleTypes';
import { BuyerCakeSchedule } from '../../../types';

const initialState: BuyerCakeScheduleState = {
  list: [],
  item: {
    ...EmptyBuyerCakeSchedule,
  },
  modal: {
    state: false,
    action: '',
  },
};

export default function(state = initialState, action: any): BuyerCakeScheduleState {
  switch (action.type) {
    case BuyerCakeScheduleAction.FETCH_BUYERCAKESCHEDULE:
      return {
        ...state,
        list: action.payload.BuyerCakeScheduleList,
      };
    
    case BuyerCakeScheduleAction.SHOW_BUYERCAKESCHEDULE:
      return {
        ...state,
        item: state.list.find(item => item.BuyerCakeScheduleEligibleCriteriaId === action.payload.id),
        modal: {
          ...action.payload.modal,
        },
      };

    case BuyerCakeScheduleAction.HIDE_BUYERCAKESCHEDULE:
      return {
        ...state,
        modal: {
          ...state.modal,
          state: false,
        },
      };

    case BuyerCakeScheduleAction.UPDATE_BUYERCAKESCHEDULE_ITEM:
      return {
        ...state,
        item: action.payload.item,
      };

    case BuyerCakeScheduleAction.SAVE_BUYERCAKESCHEDULE:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };
    
    case BuyerCakeScheduleAction.UPDATE_BUYERCAKESCHEDULE_LIST:
      return {
        ...state,
        list: action.payload.BuyerCakeScheduleList,
      };

    default:
      return state;
  }
}
